export enum TimeGrouping {
    Year = 1,
    Month = 2,
    WeekOfMonth = 3,
    DayOfWeek = 4,
    WeekOfYear = 5,
    DayOfYear = 6,
    DayOfMonth = 7,
}
